exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monaco-editor.vs-dark .glyph-margin,.monaco-editor.vs-dark .monaco-editor-background{background-color:#272822}.monaco-editor.vs-dark .view-overlays .current-line{border:2px solid rgba(96,95,84,.5)}.monaco-editor.vs-dark .view-overlays.focused .selected-text{background-color:rgba(152,139,3,.4)}.monaco-editor-hover.monaco-editor-background div:first-child{margin-left:1px}.monaco-editor.vs-dark .monaco-editor-hover{border-color:#ccc}.monaco-editor.vs-dark .monaco-editor-hover [data-code]{margin:3px 0}.monaco-editor.vs-dark .monaco-editor-hover code{padding:0 3px;background-color:#555}.monaco-editor.vs-dark .bracket-match{background-color:hsla(0,0%,39%,.3)}.editor-widget.find-widget{display:none!important}.cdr.currentFindMatch{border:1px solid #fff;background-color:#6d4f3a}.monaco-editor.mac .margin-view-overlays .line-numbers,.monaco-editor .margin-view-overlays .line-numbers{cursor:pointer}.monaco-editor .zone-widget .zone-widget-container:focus{outline:none}.monaco-editor .zone-widget .zone-widget-container .block.title{font-family:monospace;padding-top:2px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/monaco/editor/codeEditor.css
 ** module id = 195
 ** module chunks = 0
 **/